import { post, toJson, handleSerializedResponse } from 'api'

const isCreateTokenResponseOk = response => {
    if (!response.ok) throw new Error('Unable to create credit card token!')

    return response
}

const extractValuesFromResponse = ({ CardLast4, ccToken, ExpDate }) => ({ CardLast4, ccToken, ExpDate })

export const createCCToken = (token, CardNumber, CardExpiryMMYY, ZipCode) =>
    post(`${GRS_ACCOUNTS_SERVICE}/CreateCCToken`, {
        Token: token,
        CardNumber,
        CardExpiryMMYY,
        ZipCode,
    })
        .then(isCreateTokenResponseOk)
        .then(toJson)
        .then(handleSerializedResponse)
        .then(extractValuesFromResponse)
